import axios from "axios";

const baseUrl = '/api/dashboard';

export const getDashboardData = () => axios.get(`${baseUrl}/data`)